import React, { Component } from "react";
import {
  GridContainer,
  GridRow,
  GridColumn,
  Button,
  Input,
  Label,
} from "arv-reactcomponents";
import { inject, observer } from "mobx-react";
import { PAYMENTPAGE } from "npmlinks-constants";
import DynamicImportComponent from "../DynamicImportComponent";
import PropTypes from "prop-types";

@inject("PaymentStore")
@observer
class PaymentOptions extends Component {
  constructor() {
    super();
    this.toggleValue = this.toggleValue.bind(this);
  }

  toggleValue(e, paymentOptionClicked) {
    e.preventDefault();
    if (e.key && e.key !== "Enter") {
      return;
    }
    this.props.PaymentStore.togglePaymentOptions(paymentOptionClicked);
  }
  get paymentOptionsSelection() {
    return this.props.PaymentStore.paymentOptionsSelection;
  }

  componentDidCatch(error, errorInfo) {}

  render() {
    const PaymentTypeOptions = Object.keys(
      this.props.PaymentStore.PaymentTypeOptions,
    );

    return (
      <div>
        {PaymentTypeOptions.map((paymentOptionKey, i) => [
          <GridRow className="nw-paymentoptions-option">
            <GridColumn>
              <Input
                key={`${PaymentTypeOptions}${i}`}
                id={paymentOptionKey}
                className="nwc-inp-radio-primary nw-paymentoption-radio"
                type="radio"
                disabled={this.props.OptionStatus}
                value={paymentOptionKey}
                checked={this.paymentOptionsSelection[paymentOptionKey]}
                onChange={e => {
                  this.toggleValue(e, paymentOptionKey);
                }}
              />
              <Label
                htmlFor={paymentOptionKey}
                className="nw-paymentoptions-radio"
              >
                {PAYMENTPAGE.PAYMENTTYPE_TITLE[paymentOptionKey]}
              </Label>
            </GridColumn>
          </GridRow>,
          this.paymentOptionsSelection[paymentOptionKey] && (
            <GridRow className="nw-paymentoptions-dynamic-comp">
              <GridColumn>
                <DynamicImportComponent
                  component={`${
                    PAYMENTPAGE.COMPONENTWALLET_MAPPING[paymentOptionKey]
                  }`}
                />
              </GridColumn>
            </GridRow>
          ),
        ])}
      </div>
    );
  }
}
PaymentOptions.wrappedComponent.propTypes = {
  PaymentStore: PropTypes.shape({
    paymentOptionsSelection: PropTypes.shape({}),
    PaymentTypeOptions: PropTypes.shape({}),
    paymentOptions: PropTypes.shape({}),
    resetPaymentOptions: PropTypes.func,
    togglePaymentOptions: PropTypes.func,
  }).isRequired,
  OptionStatus: PropTypes.bool.isRequired,
};

const getFinalComponent = component =>
  inject("PaymentStore")(observer(component));

const ProjectComponent = {
  getFinalComponent,
  wrapper: PaymentOptions.wrappedComponent,
  component: PaymentOptions,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PaymentOptions/index.js